import React, { useState, useEffect, useContext } from 'react'
import { useSignal } from "@preact/signals-react"
import { StoreContext } from "../../context/StoreContext"
import Utility from "../../objects/Utility"
import InputFill from "../InputFill/InputFill"
import InputColor from "../InputColor/InputColor"
import './SheetEdit.scss'

const SheetEdit = ({ changeSheetMenuEditOpened, hiliteSlots, hiliteTargetSlotIndex, moveToNext }) => {
    const controller = new AbortController();
    const { state, actions } = useContext(StoreContext)
    const [sheetEditOpen, setSheetEditOpen] = useState(false)
    const [commonInputs, setCommonInputs] = useState([])
    const [slotLayerKeysNames, setSlotLayerKeysNames] = useState([])
    const signalSlotsChangedTrigger = useSignal(false)
    const [editSelections, setEditSelections] = useState([])
    const [selectedLayerKey, setSelectedLayerKey] = useState('')
    const [editSelectionActive, setEditSelectionActive] = useState(null)
    const [currentSelectionInputEdit, setCurrentSelectionInputEdit] = useState(null)
    const [controlEditing, setControlEditing] = useState('')
    const [editingTargetSlotIndex, setEditingTargetSlotIndex] = useState(-1)
    const [editValue, setEditValue] = useState(null)
    useEffect(() => {
        return () => {
            controller.abort();
        };

    }, []) // eslint-disable-line react-hooks/exhaustive-deps 

    const setupCommonInputs = () => {
        let occupied = state.slots.filter(slot => slot.counterState)
        let _commonInputs = []
        let inputLibrary = []
        let _slotLayerKeysNames = []

        occupied.forEach(oc => {
            let entry = {}
            entry.slotNumber = oc.number
            entry.layersData = []

            oc.counterState.package.layers.forEach(layer => {
                let layerName = layer.layerName

                let layerInputs = layer.inputs
                let stateLayer = state.layers.find(ly => ly.layerKey === layer.layerKey)
                if (!stateLayer) {
                    stateLayer = state.layers.find(ly => ly.layerKey === layer.parentLayerKey)
                }
                stateLayer.inputs.forEach(input => {
                    let found = _commonInputs.find(ci => ci.named === input.named)
                    if (!found) {
                        inputLibrary.push(input)
                        _commonInputs.push({
                            named: input.named,
                            locations: [{ slotNumber: oc.number, layerKeys: [layer.layerKey] }]
                        })
                    }
                    else {
                        let location = found.locations.find(loc => loc.slotNumber === oc.number)
                        if (location) {
                            let layerKeys = location.layerKeys
                            if (!layerKeys.includes(layer.layerKey)) {
                                layerKeys.push(layer.layerKey)
                            }
                        }
                        else {
                            found.locations.push({ slotNumber: oc.number, layerKeys: [layer.layerKey] })
                        }
                    }
                })
                let layerType = determineLayerType(layer.layerKey, layer.parentLayerKey)
                _slotLayerKeysNames.push({ slotNumber: oc.number, layerKey: layer.layerKey, layerName: layerName, layerType })
            })

        })
        // console.log('and we have _commonInputs:', _commonInputs)
        // console.log('and we have inputLibrary:', inputLibrary)
        setCommonInputs(_commonInputs)
        setSlotLayerKeysNames(_slotLayerKeysNames)
    }

    const determineLayerType = (layerKey, parentLayerKey) => {
        let parentLayers = state.layers.filter(layer => layer.parentLayerKey === -1)
        if (parentLayerKey > -1) {
            let parentLayer = parentLayers.find(layer => layer.layerKey === parentLayerKey)
            if (parentLayer) {
                return parentLayer.layerName
            }
        }
        let layer = parentLayers.find(layer => layer.layerKey === layerKey)
        if (layer) {
            return layer.layerName
        }

        return ''
    }

    useEffect(() => {
        if (slotLayerKeysNames.length > 0) {
            //console.log('and we have slotLayerKeysNames:', slotLayerKeysNames)
            let _editSelections = []

            slotLayerKeysNames.forEach(slotLayer => {
                let found = _editSelections.find(es => es.layerName === slotLayer.layerName)
                if (found) {
                    if (found.slotNumbers.find(sn => sn === slotLayer.slotNumber) === undefined) {
                        found.slotNumbers.push(slotLayer.slotNumber)
                    }
                }
                else {
                    _editSelections.push({
                        layerName: slotLayer.layerName,
                        layerKey: slotLayer.layerKey,
                        layerType: slotLayer.layerType,
                        slotNumbers: [slotLayer.slotNumber]
                    })
                }
            })
            setEditSelections(_editSelections)
        }
    }, [slotLayerKeysNames]) // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        if (editSelections.length > 0) {
            console.log('useEffect editSelections:', editSelections)
        }
    }, [editSelections]) // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        changeSheetMenuEditOpened(sheetEditOpen)
        if (sheetEditOpen) {
            if (commonInputs.length === 0) {
                //console.log('useEffect sheetEditOpen')
                setupCommonInputs()
            }
        }
        else {
            setCommonInputs([])
            setSlotLayerKeysNames([])
            setEditSelections([])
            
            signalSlotsChangedTrigger.value = false
            setSelectedLayerKey('')
            setEditSelectionActive(null)
            setCurrentSelectionInputEdit(null)
            setControlEditing('')
            setEditingTargetSlotIndex(-1)
        }
    }, [sheetEditOpen]) // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {

        if (commonInputs.length > 0 && sheetEditOpen) {
            //console.log('useEffect state.slots')
            if (signalSlotsChangedTrigger.value === false) {
                signalSlotsChangedTrigger.value = true
                setupCommonInputs()
            }
        }
    }, [state.slots])

    useEffect(() => {
        // console.log('useEffect commonInputs:', commonInputs)
        setTimeout(() => {
            signalSlotsChangedTrigger.value = false
        }, 200)
    }, [commonInputs]) // eslint-disable-line react-hooks/exhaustive-deps

    const onChangeLayerSelect = evt => {
        let layerKey = Number(evt.target.value)
        setSelectedLayerKey(layerKey)
    }

    useEffect(() => {
        if (selectedLayerKey) {
            //console.log('useEffect selectedLayerKey:', selectedLayerKey)
            // find parent layer type, and get the settings available for that type
            // console.log('looking for selectedLayerKey:', selectedLayerKey, 'in editSelections:', editSelections)
            let found = editSelections.find(slkn => slkn.layerKey === selectedLayerKey)
            if (found) {
                //console.log('found:', found)

                // get the settings available for that type
                let foundInputs = state.layers.find(layer => layer.layerName === found.layerType)
                if (foundInputs) {
                    // console.log('found layer inputs:', foundInputs.inputs)
                    // setEditSelectionActive(found)
                    found.inputs = foundInputs.inputs
                }

                setEditSelectionActive(found)
                //setEditingTargetSlotIndex(0)
            }
            else {
                //  console.log('did not find layerKey', selectedLayerKey, 'in editSelections:', editSelections)
                setEditSelectionActive(null)
                //setEditingTargetSlotIndex(-1)
            }
        }
        else {
            setEditSelectionActive(null)
           // setEditingTargetSlotIndex(-1)
        }
    }, [selectedLayerKey]) // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        if (editSelectionActive) {
            console.log('useEffect editSelectionActive:', editSelectionActive)
            let { layerName, layerKey, layerType, slotNumbers, inputs } = editSelectionActive
            console.log('layerName:', layerName)
            console.log('layerKey:', layerKey)
            console.log('layerType:', layerType)
            console.log('slotNumbers:', slotNumbers)
            console.log('inputs:', inputs)
            console.log('lets highlight these slots:', slotNumbers)
            editHighlightSlots(slotNumbers)

        }
    }, [editSelectionActive]) // eslint-disable-line react-hooks/exhaustive-deps

    const editHighlightSlots = (slots) => {
        hiliteSlots(slots)
    }

    useEffect(() => {
        hiliteTargetSlotIndex(editingTargetSlotIndex)
    }, [editingTargetSlotIndex]) // eslint-disable-line react-hooks/exhaustive-deps

    const onChangeSelectionInputEdit = evt => {
        if (currentSelectionInputEdit !== evt.target.value) {
            setCurrentSelectionInputEdit(evt.target.value)
        }
    }

    const onChangeSelectionInputEditSpan = id => {
        if (currentSelectionInputEdit !== id && id) {
            setCurrentSelectionInputEdit(id)
            let radiobtn = document.getElementById(id);
            if (radiobtn) {
                radiobtn.checked = false;
                setTimeout(() => {
                    radiobtn.checked = true;
                }, 10)
            }
        }
    }

    useEffect(() => {
        if (currentSelectionInputEdit) {
            setupControlsForInput()
        }
    }, [currentSelectionInputEdit])

    const setupControlsForInput = () => {
        // currentSelectionInputEdit
        let controlToEdit = editSelectionActive.inputs.find(esai => esai.named === currentSelectionInputEdit)
        if (controlToEdit) {
            setControlEditing(controlToEdit)
            console.log('calling setEditingTargetSlotIndex')
            setEditingTargetSlotIndex(0)
        }
    }

    const deployControl = () => {
        switch (controlEditing.type) {
            case "color": return <InputColor key="1" theme="sheet-edit"
                layerKey="1"
                input={controlEditing}
                setValue={setValue}
                useValue="#ffffff"
            //useValue={JSON.parse(signalValues.v[input.inputKey])}
            />

            default: return ''
        }
        
    }

    const setValue = (inputKey, val) => {
        console.log('setValue inputKey:', inputKey, 'got:', val)
        setEditValue(val)
    }

    const handleNextSlot = () => {
        console.log('handleNextSlot, editingTargetSlotIndex:', editingTargetSlotIndex)
        let nextSlotIndex = editingTargetSlotIndex + 1
        console.log('nextSlotIndex:', nextSlotIndex)
        if (nextSlotIndex >= editSelectionActive.slotNumbers.length) {
            console.log('setting to 0') 
            nextSlotIndex = 0
        }
        console.log('calling setEditingTargetSlotIndex:', nextSlotIndex)
        setEditingTargetSlotIndex(nextSlotIndex)
    }

    const applyEdit = () => {
        if(editValue !== null) {
            if(controlEditing.type === 'color') {

            }
        }
    }

    const applyEditAll = () => {

    }

    return (

        <div className={sheetEditOpen ? 'sheet-edit opened' : 'sheet-edit'}>

            <div className={sheetEditOpen ? 'controls-opener opened' : 'controls-opener closed'}>
                <div className="title">sheet edit {sheetEditOpen ? 'open' : 'closed'}</div>
                <button className={sheetEditOpen ? 'standard-button yellow closed' : 'standard-button yellow'} onClick={() => setSheetEditOpen(false)}>open</button>
                <button className={sheetEditOpen ? 'standard-button red' : 'standard-button red closed'} onClick={() => setSheetEditOpen(false)}>close</button>
            </div>

            <div className={sheetEditOpen ? 'controls' : 'display-none'}>
                <div className="controls-container">

                    <div className="popupable" data-popup="Select layer"
                        onClick={actions.popupInfoActive}>select layer to edit</div>


                    <div>
                        <select className="layer-select" onChange={onChangeLayerSelect} value={selectedLayerKey}>
                            <option value="">Select layer</option>
                            {editSelections.map((cs, index) => {
                                return (
                                    <option key={index} value={cs.layerKey}>{cs.layerName} ({cs.slotNumbers.length} slots)</option>
                                )
                            })}
                        </select>
                    </div>

                </div>

                {editSelectionActive ?
                    <div className="controls-container input-selection">

                        <div className="title">edit <span className="layer-name">{editSelectionActive.layerName}</span>

                            {editSelectionActive.layerName !== editSelectionActive.layerType ?
                                <span> of type <span className="type-name">{editSelectionActive.layerType}</span> </span>
                                : ''}
                        </div>

                        <div>Which setting do you want to edit:</div>
                        <div className="edit-selection-active-inputs">
                            {editSelectionActive.inputs.map((input, index) => {
                                return (
                                    <span key={index} onClick={() => onChangeSelectionInputEditSpan(`editInput${input.inputKey}`)}>
                                        <input type="radio"
                                            id={`editInput${input.inputKey}`}
                                            name={`editInput${input.inputKey}`}
                                            value={input.named}
                                            checked={currentSelectionInputEdit === input.named}
                                            onChange={onChangeSelectionInputEdit}
                                            onClick={onChangeSelectionInputEdit}
                                        />
                                        <label htmlFor={`editInput${input.inputKey}`}>{input.named}</label>
                                    </span>
                                )
                                //    return ( <input type="radio" key={index}>{input.named}</input> )
                            })}
                        </div>
                        {/* <div className="edit-selection">
                            {editSelectionActive.slotNumbers.map((sn, index) => {

                                return (
                                    <div key={index} className="slot">
                                        <span>Slot {sn + 1}</span>
                                        {editSelectionActive.inputs.map((input, index2) => {
                                            return (<div key={index2}>{input.named}
                                            {input.type === 'fill' ? <span>fill color: <input type="color" /></span> : ''}
                                            
                                            </div>)
                                        })}
                                    </div>
                                )

                            })}

                        </div> */}

                    </div> : ''}

                {controlEditing ?
                    <div className="controls-container input-selection deployed">
                        {deployControl()}
                        <div className="apply-slots">
                            <button className="standard-button green" onClick={applyEdit}>apply</button>
                            {editSelectionActive.slotNumbers.length > 1 ?
                                <>
                                    <button className="standard-button yellow" onClick={applyEditAll}>apply  all</button>
                                    <button className="standard-button blue" onClick={handleNextSlot}>next</button>
                                </>
                                : ''}
                        </div>
                    </div>


                    : ''}
            </div>
        </div>
    );
}
export default SheetEdit
